import script from "./EditorWrapper.vue?vue&type=script&lang=js"
export * from "./EditorWrapper.vue?vue&type=script&lang=js"

import "./EditorWrapper.vue?vue&type=style&index=0&id=5e9e0b20&lang=scss"

const __exports__ = script;

export default __exports__